// extracted by mini-css-extract-plugin
export var badge = "_gg-2";
export var detailsPanel = "_gg-0";
export var resultRow = "_gg-1";